import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';

export interface LogEntry {
  id: number;
  timestamp: string;
  level: 'INFO' | 'WARNING' | 'ERROR' | 'DEBUG' | 'CRITICAL';
  message: string;
  logger_name: string;
  module: string;
  function: string;
  line_number: number;
  user_id: number | null;
  request_path: string | null;
  request_method: string | null;
  status_code: number | null;
  exception_type: string | null;
  exception_message: string | null;
  traceback: string | null;
  extra_data?: {
    taskName?: string;
    asctime?: string;
    [key: string]: any;
  };
}

export interface LogsResponse {
  logs: LogEntry[];
  total: number;
  page: number;
  page_size: number;
}

@Injectable({ providedIn: 'root' })
export class LogsService {
  constructor(private apiService: ApiService) {}

  /**
   * Get application logs with pagination
   */
  getLogs(
    params?: {
      level?: string;
      source?: string;
      module?: string;
      logger_name?: string;
      page?: number;
      page_size?: number;
      limit?: number;
      offset?: number;
    },
    skipGlobalLoader = false,
  ): Observable<LogsResponse> {
    return this.apiService.get<LogsResponse>('/admin/logs', params, true, skipGlobalLoader);
  }

  /**
   * Get application logs as array (for backward compatibility)
   */
  getLogsArray(
    params?: {
      level?: string;
      source?: string;
      module?: string;
      logger_name?: string;
      page?: number;
      page_size?: number;
      limit?: number;
      offset?: number;
    },
    skipGlobalLoader = false,
  ): Observable<LogEntry[]> {
    return this.getLogs(params, skipGlobalLoader).pipe(map((response) => response.logs));
  }
}
